import { mergeSx } from "ui/merge-sx";
import { Typography, type TypographyProps } from "ui/typography";

interface LegendProps extends Omit<TypographyProps, "variant"> {
  size?: "sm" | "lg";
}

/**
 * `sm` renders the eyebrow treatment (`h5`), `lg` the section heading (`h3`). Only
 * `ui/forms/form-group` renders this, and it never overrides the `lg` default — the `sm` branch is
 * kept because `legendSize` is a public prop, not because anything uses it.
 *
 * `sx` is destructured out and merged rather than left in `rest`: `form-group` passes its own
 * `sx={{ mb: … }}`, and a spread carrying `sx` would replace the colour wholesale instead of adding
 * to it. Caller last, so an explicit colour still wins.
 */
const Legend = ({ size = "lg", sx, ...rest }: LegendProps) =>
  size === "lg" ? (
    <Typography variant="h3" {...rest} sx={mergeSx({ color: "secondary.main" }, sx)} />
  ) : (
    <Typography variant="h5" {...rest} sx={mergeSx({ color: "text.secondary" }, sx)} />
  );

export default Legend;
